import type { DistanceOptions } from '../../types';
import type { TranslationKey } from '@shared/constants/translations';
import type { Optional } from '@shared/types/utils';

const entityTypes = {
  CITY: 'CITY_CENTER',
  NAMED_ENTITY: 'NAMED_ENTITY',
  LARGER_THAN_CITY: 'LARGER_THAN_CITY',
  HOTEL: 'HOTEL',
};

const shouldRenderDistanceNode = (referenceEntityType?: string) =>
  referenceEntityType === entityTypes.HOTEL ||
  referenceEntityType === entityTypes.CITY ||
  referenceEntityType === entityTypes.NAMED_ENTITY;

const getDistanceLabel = ({
  isMobile = false,
  referenceEntityName,
  referenceEntityType,
}: {
  referenceEntityName?: string;
  referenceEntityType?: string;
  isMobile?: boolean;
}): {
  options?: DistanceOptions;
  label?: TranslationKey;
  distancePlaceholder?: string;
  data?: Record<string, any>;
} => {
  let options: Optional<DistanceOptions>;
  let label: Optional<TranslationKey>;
  let distancePlaceholder: Optional<string>;
  let data: Optional<Record<string, any>>;
  if (referenceEntityType === entityTypes.HOTEL) {
    options = {
      kmString: 'Distance_label_fromHotelKm',
      milesString: 'Distance_label_fromHotelMiles',
    };
  }

  if (referenceEntityType === entityTypes.CITY) {
    label = 'Distance_label_fromCityCentre';
  }

  if (referenceEntityType === entityTypes.NAMED_ENTITY) {
    const showFromPlaceMore =
      (isMobile && referenceEntityName!.length > 30) ||
      referenceEntityName!.length > 40;

    if (showFromPlaceMore) {
      label = 'Distance_label_fromPlaceMore';
      distancePlaceholder = '0';
    } else {
      label = 'Distance_label_fromPlace';
      data = {
        place: referenceEntityName,
      };
    }
  }

  return {
    options,
    label,
    distancePlaceholder,
    data,
  };
};

export { shouldRenderDistanceNode, getDistanceLabel };
